import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  Component,
  EventEmitter,
  Input,
  NgZone,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ObjectUtils } from '@egym/ngx-adm-int';
import { Filter } from 'src/app/model/search-filters/filter';
import { SearchFilter } from 'src/app/model/search-filters/search-filter';
import { SearchFilterItem } from 'src/app/model/search-filters/search-filter-item';
import { AddItemDialogComponent } from './add-item-dialog/add-item-dialog.component';

@Component({
  selector: 'gymfinder-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: ['./search-filter.component.scss'],
  standalone: false,
})
export class SearchFilterComponent implements OnInit {
  @Input()
  searchFilter: SearchFilter;

  @Output()
  searchFilterChange = new EventEmitter<SearchFilter>();

  @Input()
  availableFilters: Filter[];

  @Input()
  supportAddItem = true;

  private _slug?: string;

  private _items?: SearchFilterItem[];

  constructor(
    private dialog: MatDialog,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    this._slug = this.searchFilter.slug;
    this._items = this.searchFilter.items?.sort((a, b) =>
      a.order < b.order ? -1 : 1
    );
  }

  get slug(): string | undefined {
    return this._slug;
  }

  set slug(newValue: string | undefined) {
    this._slug = newValue;
    this.searchFilter.slug = newValue;
    this.searchFilterChange.emit(this.searchFilter);
  }

  get items(): SearchFilterItem[] | undefined {
    return this._items;
  }

  addNewItem() {
    this.ngZone.run(() => {
      const dialogRef = this.dialog.open(AddItemDialogComponent, {
        data: { availableFilters: this.availableFilters },
      });
      dialogRef.afterClosed().subscribe({ next: n => this.addItem(n) });
    });
  }

  private addItem(item: SearchFilterItem | undefined) {
    if (item) {
      if (!this.searchFilter.items) {
        this.searchFilter.items = [];
      }
      item.order = this.searchFilter.items.length;
      this.searchFilter.items = [...this.searchFilter.items, item];
      this.searchFilterChange.emit(ObjectUtils.deepCopy(this.searchFilter));
    }
  }

  onItemChanged(item: SearchFilterItem, index: number) {
    if (item) {
      if (!this.searchFilter.items) {
        this.searchFilter.items = [];
      }

      this.searchFilter.items.splice(index, 1, item);
      this.searchFilterChange.emit(this.searchFilter);
    }
  }

  searchItemDropped(event: CdkDragDrop<SearchFilterItem[]>) {
    if (this.searchFilter.items) {
      moveItemInArray(
        this.searchFilter.items,
        event.previousIndex,
        event.currentIndex
      );
      this.searchFilter.items.forEach((item, index) => {
        item.order = index;
      });
      this.searchFilterChange.emit(this.searchFilter);
    }
  }

  public onItemRemove(index: number) {
    this.searchFilter.items?.splice(index, 1);
    this.searchFilterChange.emit(this.searchFilter);
  }
}
